/** Cloudflare Worker proxy in front of Lambda Function URLs (avoids *.on.aws ISP blocks). */
export const API_PROXY_BASE_URL =
  import.meta.env.VITE_API_PROXY_BASE_URL ||
  "https://api-proxy.meritcurve.workers.dev";

export const FUNCTION_BASE_URL =
  import.meta.env.VITE_FUNCTION_BASE_URL ||
  "https://us-central1-meritcurve-prod-86c3a.cloudfunctions.net";

export const CLIENT_FUNCTION_BASE_URL =
  import.meta.env.VITE_CLIENT_FUNCTION_BASE_URL || API_PROXY_BASE_URL;

export const SERVERLESS_CLIENT_LAMBDA_BASE_URL =
  import.meta.env.VITE_SERVERLESS_CLIENT_LAMBDA_BASE_URL ||
  import.meta.env.VITE_SERVERLESS_FUNCTION_BASE_URL ||
  API_PROXY_BASE_URL;

export const SERVERLESS_ASSESSMENT_LAMBDA_BASE_URL =
  import.meta.env.VITE_SERVERLESS_LAMBDA_BASE_URL
    ? `${import.meta.env.VITE_SERVERLESS_LAMBDA_BASE_URL}/assessment`
    : `${API_PROXY_BASE_URL}/assessment`;
